import axios from "axios";

export const STORAGE_KEY = 'AC_API_API';

export const getACApi = () => {
    const data = localStorage.getItem(STORAGE_KEY);

    if (!data) {
        return null;
    };

    return JSON.parse(data);
}

export const getVoiceApi = () => getACApi()?.digital || process.env.REACT_APP_ServerBaseURL;

// Default Cognito config values
const DEFAULT_COGNITO_CONFIG = {
    domain: 'https://rbc-lens.auth.ca-central-1.amazoncognito.com',
    clientId: '11k3qvvfhr41n0i3t2sui0c7vj',
    responseType: 'token',
    scope: 'email openid phone lens-api/admin lens-api/delete lens-api/read lens-api/write'
};

// Fetch Cognito config from backend API
export const fetchCognitoConfig = async () => {
    try {
        const baseUrl = getVoiceApi();
        const response = await axios.get(`${baseUrl}api/config/v1/`);

        if (response.data?.code === 'success' && response.data?.data) {
            const configItems = response.data.data;
            const config = {};

            // Map config items to cognito config object
            configItems.forEach(item => {
                if (item.configName === 'cognito.domain') {
                    config.domain = item.configValue;
                } else if (item.configName === 'cognito.clientId') {
                    config.clientId = item.configValue;
                } else if (item.configName === 'cognito.responseType') {
                    config.responseType = item.configValue;
                } else if (item.configName === 'cognito.scope') {
                    config.scope = item.configValue;
                }
            });

            return {
                domain: config.domain || DEFAULT_COGNITO_CONFIG.domain,
                clientId: config.clientId || DEFAULT_COGNITO_CONFIG.clientId,
                responseType: config.responseType || DEFAULT_COGNITO_CONFIG.responseType,
                scope: config.scope || DEFAULT_COGNITO_CONFIG.scope
            };
        }

        return DEFAULT_COGNITO_CONFIG;
    } catch (error) {
        console.error('Failed to fetch Cognito config:', error);
        return DEFAULT_COGNITO_CONFIG;
    }
};

// Synchronous getter (returns defaults, use fetchCognitoConfig for async fetch)
export const getCognitoConfig = () => {
    return DEFAULT_COGNITO_CONFIG;
};
